import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
import updateLocale from 'dayjs/plugin/updateLocale';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';

function regiterPlugins() {
  dayjs.extend(utcPlugin);
  dayjs.extend(updateLocale);
  dayjs.extend(localeData);
  dayjs.extend(weekday);
}

async function setupDayjsLocale() {
  // Get browser locale
  const browserLocale = navigator.language || 'en';
  const normalizedLocale = browserLocale.toLowerCase().replace('_', '-');
  const languageCode = normalizedLocale.split('-')[0];

  let loadedLocale = 'en'; // Default fallback

  try {
    // Try to load the exact locale
    try {
      // Dynamic import of the exact locale
      await import(`dayjs/locale/${normalizedLocale}.js`);
      dayjs.locale(normalizedLocale);
      loadedLocale = normalizedLocale;
    } catch (e) {
      // If exact locale fails, try with just the language code
      await import(`dayjs/locale/${languageCode}.js`);
      dayjs.locale(languageCode);
      loadedLocale = languageCode;
    }
  } catch (e) {
    // If all fails, stay with English
    console.warn(`Could not load locale for ${browserLocale}, falling back to English`);
    try {
      await import('dayjs/locale/en.js');
      dayjs.locale('en');
    } catch (err) {
      // English is built-in, so this shouldn't happen
      console.error('Failed to load English locale:', err);
    }
  }

  const weekStart = dayjs.localeData().firstDayOfWeek();
  dayjs.locale('en');
  dayjs.updateLocale('en', { weekStart });

  return loadedLocale;
}

async function initDayjs() {
  regiterPlugins();
  await setupDayjsLocale();
}

export default initDayjs;
